export default "/assets/images/outdoor-air-tracking-sm.bb7dd5a1819712fc.jpg";